import { FlowStepSequence } from "./FlowStepSequence";
import { FlowStepOutputInstructions } from "./FlowStepOutputInstructions";
import { FlowStepData } from "../Steps/FlowStepData";

export class FlowConnection {
    fromSequence: FlowStepSequence;
    toSequence?: FlowStepSequence;
    fromInstruction: FlowStepOutputInstructions;
    fromStep: FlowStepData;
    fromId: string;
    toId: string;
    isCandidate: boolean;
    isReturn: boolean;

    constructor(
        fromId: string,
        toId: string,
        isCandidate: boolean,
        fromSequence: FlowStepSequence,
        fromInstruction: FlowStepOutputInstructions,
        fromStep: FlowStepData,
        isReturn: boolean = false,
        toSequence?: FlowStepSequence
    ) {
        this.fromSequence = fromSequence;
        this.fromInstruction = fromInstruction;
        this.fromStep = fromStep;
        this.fromId = fromId;
        this.toId = toId;
        this.isCandidate = isCandidate;
        this.isReturn = isReturn;
        this.toSequence = toSequence;
    }
}
